/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RequestAuthLinkInput = {|
  email: string,
  code_challenge: string,
  redirect_uri: string,
  clientMutationId?: ?string,
|};
export type loginContextualRequestLinkMutationVariables = {|
  input: RequestAuthLinkInput
|};
export type loginContextualRequestLinkMutationResponse = {|
  +requestAuthLink: ?{|
    +errors: ?{|
      +email: ?string
    |}
  |}
|};
export type loginContextualRequestLinkMutation = {|
  variables: loginContextualRequestLinkMutationVariables,
  response: loginContextualRequestLinkMutationResponse,
|};
*/


/*
mutation loginContextualRequestLinkMutation(
  $input: RequestAuthLinkInput!
) {
  requestAuthLink(input: $input) {
    errors {
      email
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestAuthLinkPayload",
    "kind": "LinkedField",
    "name": "requestAuthLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestAuthEmailErrors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loginContextualRequestLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "loginContextualRequestLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b5b5b040176d83bf93ec2381e59c2a54",
    "id": null,
    "metadata": {},
    "name": "loginContextualRequestLinkMutation",
    "operationKind": "mutation",
    "text": "mutation loginContextualRequestLinkMutation(\n  $input: RequestAuthLinkInput!\n) {\n  requestAuthLink(input: $input) {\n    errors {\n      email\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4aa3d8cc97ed16b30da33cca8a8b6709';

export default node;
